import { Client } from "../client";
import { batchActions } from 'redux-batched-actions';

import {
  prepareOrderSceletonWithDefaults,
  getSizeParams,
  recalculateShirtPrice,
  getUserMaleSize,
  checkAttrDataValueEnums
} from "../selectors/entities/general";

import {
  TryParseJsonFromPlainCode
} from "../components/helpers/clientHelper";

import store from '../store/redux_store';

import * as types from '../constants/actionTypes'
import { getNormalizedButtonsValues, getContrastFabricDataValues } from "../selectors/entities/config";
import { getFabricDataWithFiltersAndSearch } from "../selectors/entities/filters";
import { onButtonChanged,
  onFabricChanged, 
  onDetailChanged, 
  onContrastChanged, 
} from "./render";
import { toggleSetParamsError } from "./ui";

import { applyPreset } from "./ui";

export function getFabricConfig() {
  return async (dispatch, getState) => {
    dispatch({ type: types.FABRIC_CONFIG_REQUEST }, getState);
    let data;
    try {
      const response = await Client.getFabricJS();
      data = TryParseJsonFromPlainCode(response);
    } catch (error) {
      dispatch(batchActions([
        {
          type: types.FABRIC_CONFIG_FAILURE,
          error,
        },
      ]), getState);
      return { error };
    }
    dispatch(batchActions([
      { type: types.FABRIC_CONFIG_RECEIVED, data },
      { type: types.FABRIC_CONFIG_SUCCESS },
    ]));

    return { data };
  };
}

export function getAttrConfig() {
  return async (dispatch, getState) => {
    dispatch({ type: types.ATTR_CONFIG_REQUEST }, getState);

    let data;
    try {
      const response = await Client.getAttrJS();
      data = TryParseJsonFromPlainCode(response);
    } catch (error) {

      dispatch(batchActions([
        {
          type: types.ATTR_CONFIG_FAILURE,
          error,
        },
        //logError(error)(dispatch),
      ]), getState);
      return { error };
    }

    dispatch(batchActions([
      { type: types.ATTR_CONFIG_RECEIVED, data },
      //{ type: types.FABRIC_CONFIG_SUCCESS },
    ]));
    return { data };
  };
}



export function getInStockConfig() {
  return async (dispatch, getState) => {
    dispatch({ type: types.IN_STOCK_CONFIG_REQUEST }, getState);

    let data;
    try {
      const response = await Client.getInStockPHP();
      data = TryParseJsonFromPlainCode(response);
    } catch (error) {

      dispatch(batchActions([
        {
          type: types.IN_STOCK_CONFIG_FAILURE,
          error,
        },
        //logError(error)(dispatch),
      ]), getState);
      return { error };
    }


    dispatch(batchActions([
      { type: types.IN_STOCK_CONFIG_RECEIVED, data },
      { type: types.IN_STOCK_CONFIG_SUCCESS },
      //      { type: types.BUTTONS_CONFIG_SYNCHRONIZED, data: filteredButtons },
    ]));

    return { data };
  };
}

export function setDefaults() {
  return async (dispatch, getState) => {

    const fabricEnums = getFabricDataWithFiltersAndSearch(getState());
    const buttonsEnums = getNormalizedButtonsValues(getState());

    //По требованию заказчика, необходимо сразу установить во все позиции определенные материалы
    onButtonChanged(buttonsEnums[0].attrValue)(dispatch, getState);
    applyPreset('business')(dispatch, getState);
    onFabricChanged(fabricEnums[0].article)(dispatch, getState);
  };
}

export function setParams (shirtId) {
  return async (dispatch, getState) => {
    const toggleSetParamsModal = (state, value, section) => {
      console.info(`%cwe have some problems with value (${value}) for section (${section})`, 'color: magenta;')
      if(!state.ui.setParamsError) {
        toggleSetParamsError(true)(dispatch, getState);
      }
    }

    const designId = await Client.getDesignId(shirtId);
    if(designId.hasOwnProperty('error_message')) {
      return false;
    }
    const details = await Client.getDetailsById(designId.id);
    if(details.hasOwnProperty('error_message')) {
      return false;
    }

    const fabricEnums = getFabricDataWithFiltersAndSearch(getState());
    const contrastFabricEnums = getContrastFabricDataValues(getState());
    const buttonsEnums = getNormalizedButtonsValues(getState());

    const fabric = fabricEnums.filter(f => f.article === details.fabric)
    if(fabric.length > 0) {
      onFabricChanged(fabric[0].article)(dispatch, getState);
    } else {
      toggleSetParamsModal(getState(), details.fabric, 'fabric');
    }

    const button = buttonsEnums.filter(b => String(b.attrValue) === details.buttons)
    if(button.length > 0) {
      onButtonChanged(button[0].attrValue)(dispatch, getState);
    } else {
      toggleSetParamsModal(getState(), details.buttons, 'button');
    }

    for (let section in details) {
      let value = details[section];
      if (!value || section === 'fabric' || section === 'buttons' || section === 'embroideryVariant') {
        continue;
      }

      if(section === 'collarFabric' || 
         section === 'cuffFabric' || 
         section === 'cuffTurnFabric' || 
         section === 'collarStandFabric' || 
         section === 'fasteningButtonsFabric' ||
         //контрасты которые не меняются в конструкторе
         section === 'collarStandFrontFabric' ||
         section === 'sleeveFabric' ||
         section === 'fasteningFabric' ||
         section === 'fasteningThreadsFabric' ||
         section === 'doubleCollarContrastFabric' ||
         section === 'threebleCollarContrastFabric' ||
         section === 'pocketsFabric' ||
         section === 'epaulettesFabric' ||
         section === 'patchFabric' ||
         section === 'contrastFabric') 
      {
        if((fabric.length > 0 && fabric[0].article.toLowerCase() !== value.toLowerCase()) || fabric.length == 0) {
          const contrastFabric = contrastFabricEnums.filter(f => f.article === value)
          if(contrastFabric.length > 0) {
            dispatch(onContrastChanged(contrastFabric[0].article, section), getState());
          } else {
            toggleSetParamsModal(getState(), value, section)
          }
        }
      } else if(section === 'embroideryEastern' ||
        section === 'embroideryZodiac1' ||
        section === 'embroideryZodiac2' ||
        section === 'embroideryLogo' ||
        section === 'embroideryRUSSIA' ||
        section === 'embroideryHearts' ||
        section === 'embroidery23Febr' ||
        section === 'embroiderySmile' ||
        section === 'embroideryDifferent') 
      {
        continue;
      } else if (section === 'collarBone' ||
        section === 'collarButtons'||
        section === 'pocketButton' ||
        section === 'pocketFlap' ||
        section === 'buttonThreadDecor' ||
        section === 'suspended' ||
        section === 'collarDecor' ||
        section === 'cuffDecor' ||
        section === 'printProductNumber') 
      { //элементы для которых нужны бульки
        if(value === 'true') value = true;
        if(value === 'false') value = false;

        if(checkAttrDataValueEnums(value, section)(getState())){
          dispatch(onDetailChanged(value, section, true, true), getState())
        } else {
          toggleSetParamsModal(getState(), value, section)
        }
      } else {
        if(checkAttrDataValueEnums(value, section)(getState())){
          dispatch(onDetailChanged(value, section, true, true), getState())
        } else {
          toggleSetParamsModal(getState(), value, section)
        }
      }
    }
  };
}

export function getPresetsConfig() {
  return async (dispatch, getState) => {
    dispatch({ type: types.PRESET_CONFIG_REQUEST }, getState);

    let data;
    try {
      data = await Client.getPresetsJSON();
    } catch (error) {
      dispatch(batchActions([
        {
          type: types.PRESET_CONFIG_FAILURE,
          error,
        },
        //logError(error)(dispatch),
      ]), getState);
      return { error };
    }
    dispatch(batchActions([
      { type: types.PRESET_CONFIG_RECEIVED, data },
      { type: types.PRESET_CONFIG_SUCCESS },
    ]));
    return { data };
  };
}

export async function loadConfig(callback) {
  const promises = [
    await getFabricConfig()(store.dispatch, store.getState),
    await getAttrConfig()(store.dispatch, store.getState),
    await getInStockConfig()(store.dispatch, store.getState),
    await getPresetsConfig()(store.dispatch, store.getState),
  ];
  Promise.all(promises).then(callback);
}



export function getDesignIdShirt() {
  return async (dispatch, getState) => {
    const skeleton = prepareOrderSceletonWithDefaults(getState())
    const data = await Client.getDesignIdShirt(skeleton);
    const { id, } = data;
    if (id) {
      dispatch(
        {
          type: 'SHIRT_ID_UPDATED',
          id,
        }, getState()
      )
    } else {
      dispatch(
        {
          type: 'SHIRT_ID_FAILED',
        }, getState()
      )
    }

    if (data && data.error_id) {
      dispatch({
        type: 'UPDATE_REQUEST_ERROR',
        data,
      }, getState())
    }

    return id;
  }
}

export function addToCart() {
  return async (dispatch, getState) => {
    const state = getState()

    const skeleton = prepareOrderSceletonWithDefaults(state);
    const price = recalculateShirtPrice(state);
    const sizes = getSizeParams(state);

    // GA
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'ecommerce': {
        'currencyCode': 'RUB',
        'checkout': {
          'actionField': { 'step': 2 },
        }
      },
      'event': 'gtm-ee-event',
      'gtm-ee-event-category': 'Enhanced Ecommerce',
      'gtm-ee-event-action': 'Checkout Step 2',
      'gtm-ee-event-non-interaction': 'False',
    });

    let data;
    if (sizes.objectId) {
      data = await Client.addShirtSizeRef({ ...skeleton, ...sizes, profileId: sizes.objectId, price });
    } else {
      data = await Client.addShirt({ ...skeleton, ...sizes, price });
    }

    if (data && data.error_id) {
      dispatch({
        type: 'UPDATE_REQUEST_ERROR',
        data,
      }, getState())
    } else {
      dispatch({
        type: 'SHIRT_ADDED_TO_CART',
        data,
      })
      Client.update_cart_info();
    }

    return { data };
  };
}

export function saveShirtToProfile() {
  return async (dispatch, getState) => {
    const skeleton = prepareOrderSceletonWithDefaults(getState())
    const price = recalculateShirtPrice(getState())
    const sizes = getUserMaleSize(getState());
    const data = await Client.saveShirtInProfile({ ...skeleton, ...sizes, price })

    if (data && data.error_id) {
      dispatch({
        type: 'UPDATE_REQUEST_ERROR',
        data,
      }, getState())
    }
    return data
  };
}


export function resetContrast(data) {
  return {
    type: 'RESET_CONTRAST',
    data
  };
}

export function closeCartWidget() {
  return {
    type: 'CART_WIDGET_CLOSE',
  };
}